import {React, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link , Redirect} from 'react-router-dom';
import { toast } from "react-toastify";
import validator from 'validator';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
const Becomeaninstructor = props  => {
    const [name , setName] = useState('')
    const [email  , setEmail] = useState('')
    const [contact  , setContact] = useState('')
    const [experience , setExperience] = useState('')
    const [interest  , setInterest] = useState('')
    const [ifanyotheronlinecourse  , setCourse] = useState(-1)
    const [linkofonlinecourse  , setLinkofonlinecourse] = useState('')
    const [cvfile  , setFile] = useState('')
   
    const [issubmited  , setSubmit] = useState(false)
    
const resetvalues=async()=>{
    console.log("reset")
    setName("");
    setEmail("");
    setContact("");
    setExperience("");
    setInterest("");
    setCourse("");
    setLinkofonlinecourse("");
    setFile("");

}

    const handlerSubmit = e =>{
        e.preventDefault()
        getinstructordtails();
     }

     const getinstructordtails=async()=>{
     
        let filename = cvfile.name.split('.').pop();
        console.log("filename  ---"  + filename)
        if(email === "" || name === "" || contact === "" || experience === "" || interest === ""){
            console.log("Reqiured field")
            // toast.error("Reqiured field ")
            toast.error("All Fields are mandatory")
            return
        }
        else if(!validator.isEmail(email)){
            console.log("valid email")
            toast.error("Please enter valid email")
            return
        }

        else if(contact.length <6   || contact.length >10){
            console.log("length of 8 characters")
         
            toast.error("Please enter valid Phone no , without prefix ")
            return
        }
        else if(experience < 0  || experience > 50 ){
           
            toast.error("Please enter valid  Experience  ")
            return
        }
        else if(!name.match(/^[a-zA-Z]+$/)){
          
              toast.error(" Please enter valid Name ")
              return
            }  
            else if( filename !== "pdf" && filename !== "doc"  && filename !== "docx"){
                console.log("pdf , doc ")
                toast.error(" .pdf , .doc, .docx file allowed only")
                return
              }    
            //   else if( filename !== "doc" ){
            //     console.log("doc")
            //     toast.error(" .pdf , .doc, .docx file allowed only")
            //     return
            //   } 
            //   else if( filename !== "docx" ){
            //   console.log("docx")
            //     toast.error(" .pdf , .doc, .docx file allowed only")
            //     return
            //   }        
        else if(ifanyotheronlinecourse  === -1){
          
                toast.error("Please select yes / no - Have you previously taught online? ")
                return
              } 
        else{

           
            console.log("cvfile --"+ cvfile.name)
       
           var formData = new FormData();
            formData.append("name", name)
            formData.append("email", email)
            formData.append("contact", contact)
            formData.append("experience", experience)
            formData.append("interest", interest)
            formData.append("cvfile", cvfile)
            if(ifanyotheronlinecourse === "yes"  ){
                console.log("yes")
                formData.append("linkofonlinecourse", linkofonlinecourse) 
            }
           console.log("formData --"+ formData)

            await axios.post("BecomeAnInstructor/getbecomeAnInstructor", formData)
    
            .then(res => {
                console.log("res  ====")
               if(res.data.status ==="200"){
                toast.success("Thank You. Your response has been recorded !! ")
                console.log("Saved Successfully")
                setSubmit({ issubmited : true });
               }
               else{
                console.log("Something went wrong")
                toast.error("Something went wrong")
               }
            })

        }
        
     }
     if (issubmited) {
		return <Redirect to="/thankyoupage" />
	}
    return (
        <div>
            

 <br /> <br /> <br /> <br />
              
                <section class="get-abtstarted-section text-center">
               
                <img
                              src="/assets/images/course/cyber-security-Awareness.jpg"
                              alt="Logo"
                              width="900"
                              height="360"
                            />
                             <center>
                <h1 class="textcenter" >
                BECOME AN INSTRUCTOR 
                </h1>
               
            </center>
            </section>

            <div aria-label="breadcrumb">
           
            <ol class="breadcrumb" >
            <li class="breadcrumb-item"> <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
               <li class="breadcrumb-item active">BECOME AN INSTRUCTOR</li>
            </ol>
         </div>
         <section class="padding-default">
            <div>
               <br/><br/>
               <center>
               <h4 class="text-center">Become an Instructor</h4>
               </center>
               <br />
               <p>
                  edu plus now is an upcoming online platform in India offering programmes to help professionals
                  upskill and upgrade. By joining our outstanding team of instructors, you can enjoy the rewards of
                  helping enthusiastic and engaged learners further their education and careers.
                  At edu plus now, you have a chance to create a lasting impact on your students, earn every time a
                  student signs up for a course, grow as a leader, teacher and communicator, enjoy flexible time and
                  location, get complete support and resources for your course-creation needs, and keep track of
                  enrollments and student progress with the instructor dashboard.
               </p>
               <br /><br />
            </div>
           
         </section>

         <section class="padding-default bg-blues">
            <div class="bg_color_1">
                    <div class="main_title_2">
                        <span><em></em></span>
                        <p></p>
                        <h4>Apply Now!</h4>

                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <p>
                                <br /> <br />
                                Thank you for your interest, and here’s hoping we create excellent courses together.
                            </p>
                            <div>
                                <iframe src="https://www.youtube.com/embed/kgW10tpNfjE" title="video"
                                    frameborder="1"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <form  onSubmit={handlerSubmit}  id="fupForm" class="form-row"
                                enctype="multipart/form-data" >
                                <div class="form-group">
                                    <span class="input">
                                    <label class="input_label">
                                            <span class="input__label-content"><span></span>
                                                Name</span>
                                        </label>
                                        <input  placeholder="provide your Name"
                                            class="form-control" type="text"  value={name}   id="name" name="name" onChange={e => setName(e.target.value)}/>
                                       </span>

                                    <span class="input">
                                    <label class="input_label">
                                            <span class="input__label-content"><span></span>
                                                Email</span>
                                        </label>
                                        <input  class="form-control" type="text" id="email"  value={email}   placeholder="provide your email"  name="email" onChange={e => setEmail(e.target.value)}/>
                                        
                                    </span>
                                    <span class="input">
                                    <label class="input_label">
                                            <span class="input__label-content"><span></span> Phone
                                                No.</span>
                                        </label>
                                        <input required class="form-control" type="text" 
                                           placeholder="eg. +918010925925"  id="contact" name="contact" value={contact} onChange={e => setContact(e.target.value)} />
                                        
                                    </span>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="input">
                                            <label class="input_label">
                                                    <span class="input__label-content"><span
                                                           ></span>Areas of Interest (For eg. Data
                                                        Science, Management, Law)</span>
                                                </label>
                                                <input required class="form-control" type="text" autocomplete="on" value={interest}
                                                    name="interest" id="instrest"  onChange={e => setInterest(e.target.value)}/>
                                                
                                            </span>
                                        </div>
                                       
                                    </div>
                                   
                                    <div class="row">
                                        <div class="col-md-4">
                                            <span class="input">
                                            <label class="input_label">
                                                    <span class="input__label-content"><span ></span>
                                                        Experience</span>
                                                </label>
                                                <input required class="form-control" type="number" id="exp"  value={experience}
                                                    autocomplete="on" name="experience"  onChange={e => setExperience(e.target.value)}/>
                                                
                                            </span>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span class="input">
                                            <label class="input_label">
                                                    <span class="input__label-content"> Upload CV</span>
                                                </label>
                                                <input class="form-control" id="cvfile" type="file"
                                                    name="cvfile"
                                                    onChange={e => setFile(e.target.files[0])}  required />
                                               
                                            </span>
                                        </div>
                                    </div>
                                    <br />
                                  
                                     <input type="hidden" id="backurl" value="" />
                                    <div class="select">
                                        <div class="styled-select">
                                            <select class="form-control" required name="ifanyotheronlinecourse" id="ifanyotheronlinecourse"
                                                onChange={e => setCourse(e.target.value)}>
                                                <option value="-1">Have you previously taught online?</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                        </div>
                                    </div> 

                                    {ifanyotheronlinecourse === "yes" ? (
                                        <div class="form-group">
                                            <span class="input">
                                            <label class="input_label" >
                                                    <span class="input__label-content" id="label">Enter Links</span>
                                                </label>
                                                <input required type="text" class="form-control"  autocomplete=" on"
                                                    name="linkofonlinecourse" id="linkofonlinecourse"  onChange={e => setLinkofonlinecourse(e.target.value)}/>
                                                
                                            </span>
                                        </div>

                                        ) : (" ")}

                                
                                    <div id="captcha"></div>
                                    <br />
                                    <div class="row">
                                    <span class="text-300">*By filling out this form, you agree to receive emails regarding the
                                    latest courses and any other updates from edu plus now.</span><br />
                                    </div>
                                    <input type="submit" id="submit"  class="btn_1 btn_11 rounded" value="Send" update="message" />
                                
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="reset" name="reset" value="reset" class="btn_1 btn_11 rounded outline"   onClick={resetvalues}>Reset</button>
                            
                                </div>
                            </form>
                             
                            
                        </div>

                    </div>
                </div>     
                    
            </section>
                   



        </div>
    );
};

export default Becomeaninstructor;